export default "__VITE_ASSET__4hLhkyjU__"